import React from 'react';
import PropTypes from 'prop-types';

import RadioButtonGroup from '../input-fields/radio-button-group';

const Options = ({
  options = [],
  selectOption,
  selectedOption,
  group,
  legend,
}) => (
  <RadioButtonGroup
    options={options.map(({ id, title }) => ({
      value: id,
      label: title,
    }))}
    name={group}
    id={group}
    onChange={(event) => selectOption(event.currentTarget.value)}
    value={selectedOption}
    legend={legend}
  />
);

Options.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      group: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
    })
  ),
  selectOption: PropTypes.func.isRequired,
  selectedOption: PropTypes.string,
  group: PropTypes.string,
  legend: PropTypes.node.isRequired,
};

export default Options;
